import React, {useState, useEffect, useRef} from 'react';
import styled, {css} from 'styled-components';
import { fetchApi } from './api/fetchApi';


import ListPanel from './components/ListPanel'
import CompanyContent from './components/CompanyContent'


import CreateCompanyModal from './components/CreateCompanyModal'
import { listCompaniesApi, deleteCompany } from './api/companyApi';
import ModalDelete from './components/ModalDelete';
import Auth from 'live/services/authorization'
import { canDeleteCompany, canEditCompany } from './permissions';
import { getPermissionsLoggedUser } from './api/permissionApi';

const Companies = () => {

    const [companies, setCompanies] = useState([])
    const [companySelected, setSelectedCompany] = useState({})
    const [companyEdit, setCompanyEdit] = useState();
    const [companyToRemove, setCompanyToRemove] = useState(null);
    const [textTyped, setTextTyped] = useState(null);
    const [textToRemove, setTextToRemove] = useState(null);
    const [showDeleteCompany, setShowDeleteCompany] = useState(false);
    const [showEditCompany, setShowEditCompany] = useState(false);
    const refContainer = useRef(null);
    
    useEffect(() => {
        getPermissionsLoggedUser().then(response => {
            setShowDeleteCompany(canDeleteCompany(response.data));
            setShowEditCompany(canEditCompany(response.data));
        });
        
        listCompanies();
    }, [])

    const listCompanies = () => {
        listCompaniesApi()
        .then(response => {            
            
            const companies = response.data;
            
            if(companySelected?.id){
                let aux = companies.find(ele => companySelected.id === ele?.id);
                aux = aux ? aux : {};                
                setSelectedCompany(aux);
            }

            setCompanies(companies)               
        })
    }

    const handleCreateCompany = () => {
        setCompanyEdit({});
    }

    const handleSelectCompany = (company) => {
        setSelectedCompany(company);
    }
    
    const onEdit = (company) => {
        setCompanyEdit(company);
    }

    const closeModal = () => {
        setCompanyEdit();
        listCompanies();
        setMessageErrorResponseApi();
    }

    const deleteCompanyDB = (companyID) => {
        if(textTyped?.trim()===textToRemove?.trim()){
            deleteCompany(companyID)
            .then((response) => {
                cancelModalDeleteCompany();
                listCompanies();
            })
            .catch(error => {
            // console.log('ERROR: ', error);
            });
        }
    }

    const openModalDeleteCompany = (company) => {
        setTextToRemove(`REMOVE ${company?.name?.toUpperCase()}`);
        setCompanyToRemove(company);
    }

    const cancelModalDeleteCompany = () => {
        setCompanyToRemove(null);
        setTextToRemove(null);
        setTextTyped(null);
    }

    const TemplateDeleteCompany = ({textToRemove}) => {

        return (
            <div>
                   <div className="normal-text">
                        Are you sure you want remove the company?
                    </div>

                    <div className="important-message">
                        This action cannot be undone.<br/>
                        With the company, will be removed dashboards, rules, users, userGroups, perspectives and datasources associeted to it. 
                    </div>

                    <div className="normal-text">
                        If you really want to delete the perspective, type 
                        <span style={{"color":"red", "font-weight":"700", "margin": "0 5px"}}>
                            {textToRemove}
                        </span> 
                        in the field below before completing the action:
                    </div>

                    <input autoFocus={true} ref={refContainer} type="text" value={textTyped} onChange={(e) => {setTextTyped(e.target.value)}}/>
            </div>
        )
    }

    return(
        <App>
                 {
                     companyEdit && <CreateCompanyModal showModal={companyEdit != null} closeModal={closeModal} company={companyEdit}/>
                 }

                <ModalDelete 
                    show={companyToRemove != null}                     
                    cancel={cancelModalDeleteCompany}
                    remove={() => deleteCompanyDB(companyToRemove.id)}
                >   
                    <TemplateDeleteCompany textToRemove={textToRemove}/>
                </ModalDelete>
                
                 <ListPanel 
                 handleCreateCompany={handleCreateCompany}
                 companies={companies} 
                 selectCompany={handleSelectCompany} 
                 deleteCompany={openModalDeleteCompany}
                 companySelected={companySelected}
                 showDeleteCompany={showDeleteCompany}/> 

                 <CompanyContent company={companySelected} onEdit={onEdit} showEditCompany={showEditCompany}/>
           

        </App>
    )
}

export default Companies;


const App = styled.div`
    position: fixed;
    height: calc(100% - 85px);
    display: flex;
    top: 35px;
    width: 100%;
    background-color: #dddee1;
    /* border:5px solid yellow; */
`

